jQuery(document).on('form-success', 'form', function () {

    var form = jQuery(this);
    
    if (form.data('submitted')) {
        return;
    }
    
    form.data('submitted', true);
    
    var
        data = form.serializeJSON(),
        action = form.data('action')
    ;
    
    data.action = action ? action : 'formsubmit';
    form.find('fieldset').prop('disabled', true);
    
    jQuery.post(
        ajaxUrl,
        data,
        function (response) {

            //Handle errors
            if (typeof response.data !== 'undefined' && response.data.hasOwnProperty('errors')) {

                var errors = {};
                var submitBtn = form.find('[type="submit"]');
                for (var key in response.data.errors) {

                    if (response.data.errors.hasOwnProperty(key)) {
                        errors[key] = response.data.errors[key];
                    }
                }

                if (form.data('show-errors')) {

                    let errorsContainer = jQuery(form.data('show-errors'));

                    if (errorsContainer.length === 0) {
                        return;
                    }
                    errorsContainer.html('');
                    
                    for (const key in errors) {
                        errorsContainer.html(`<p>${errors[key]}</p>`);
                    }
                    errorsContainer.show();
                }

                form.data('validator').showErrors(response.data.errors);
                form.data('submitted', false);
                submitBtn.attr('disabled', false);
                submitBtn.text(submitBtn.data('init-value'));
                form.find('fieldset').prop('disabled', false);
                
                return;
                
            }
            
            //Handle success
            if (response.success && form.data('show')) {
                form.hide();
                jQuery(form.data('show')).fadeIn();
            }
        
        },
        'json'
    );

});